import { getInitials } from '../../getters';

/**
 * Returns a data with the initias of the user related to the data
 * @category Formatters
 * @category Object
 */
export function userResponseInterceptor(data: any) {
  if (!data) {
    return;
  }
  return {
    ...data,
    initials: getInitials(data.name || ''),
  };
}
